import Masonry from "react-masonry-css";
import React from "react";

const MasonryContainer = ({children}) =>
{
  const breakpointColumnsObj = {
    default: 3,
    1860: 2,
    1200: 1,
  };

  return <Masonry
    breakpointCols={breakpointColumnsObj}
    className="my-masonry-grid"
    columnClassName="my-masonry-grid_column"
  >
    {children}
  </Masonry>
}

export default MasonryContainer;